import Code from '../../../Shared/Code';
import ContentGenerator from '../../../Shared/ContentGenerator';

import { useChatContext } from '../../ChatController/ChatController.context';

import { Content } from '../../../../types/tour';
import { State } from '../../../../types/chat';

export type Props = {
  setComplete: (stepIndex: number, parentIndex: number) => void;
  content: Content;
};

const codeSample = (state: State) => `
const client = StreamChat.getInstance("${state.apiKey}");
await client.connectUser({
  id: "${state.userId}",
  name: "${state.userName}",
  image: "https://bit.ly/2u9Vc0r",
}, "${state.userToken}"); // token generated server side
return client;
`;

const hydrateContent = (
  USER?: string,
  content?: Content,
): Content | undefined => {
  if (USER && content) {
    return {
      ...content,
      blockquotes: content?.blockquotes?.map((b) =>
        b.replace('USER_NAME', USER),
      ),
    };
  }
};

export const Step2 = ({ setComplete, content }: Props) => {
  const { state, setClient } = useChatContext();
  const run = async () => {
    await setClient();
    setComplete(2, 1);
  };

  return (
    <ContentGenerator
      content={hydrateContent(state?.userName, content)}
      code={
        state?.apiKey && (
          <Code
            language="jsx"
            footer={{ label: 'Initialize', run, disabled: !!state.client }}
            wrapLongLines={true}
          >
            {codeSample(state)}
          </Code>
        )
      }
    />
  );
};
